<template>
  <section class="text-gray-600">
    <div class="px-4 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl sm:px-20 md:px-28 lg:px-32 lg:pt-10">
      <div class="flex justify-center items-center pt-10">
        <img :src="baseOSSUrl + '/news-1.png'" alt="" class="h-5 w-5">
        <p class="w-52 h-9 text-2xl text-center leading-9 text-lg font-bold tracking-widest">在线教育视频</p>
        <img :src="baseOSSUrl + '/news-1.png'" alt="" class="h-5 w-5">
      </div>
      <div class="flex flex-wrap w-full flex-col items-center text-center mt-4">
<!--        <p class="lg:w-full w-full leading-relaxed text-gray-400">-->
<!--          Whatever cardigan tote bag tumblr hexagon brooklyn asymmetrical gentrify, subway tile poke farm-to-table.-->
<!--        </p>-->
      </div>

      <div class="container flex flex-wrap py-10 mx-auto items-center">
        <div class="px-4 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-0 lg:px-0">
          <div class="grid gap-5 row-gap-8 lg:grid-cols-2">
            <!--   左侧视频       -->
            <div style="width: 29.375rem;height: 16.523rem;">
              <video-player
                  v-if="options"
                  class="video-player vjs-custom-skin object-cover w-full"
                  ref="videoPlayer"
                  :playsinline="true"
                  :options="options"
                  @play="onPlayerPlay($event)"
                  @pause="onPlayerPause($event)"
                  @ended="onPlayerEnded($event)"
                  @waiting="onPlayerWaiting($event)"
                  @playing="onPlayerPlaying($event)"
                  @loadeddata="onPlayerLoadeddata($event)"
                  @timeupdate="onPlayerTimeupdate($event)"
                  @canplay="onPlayerCanplay($event)"
                  @canplaythrough="onPlayerCanplaythrough($event)"
                  @statechanged="playerStateChanged($event)"
                  @ready="playerReadied"
              >
              </video-player>
            </div>
            <div class="flex flex-col justify-center relative">
              <div class="h-full pt-14 w-3 absolute inset-0 flex items-center justify-center mt-1 ">
                <div class="h-full md:border-r border-gray-200 pointer-events-none "></div>
              </div>
              <div class="flex-shrink-0 w-3 h-3 rounded-full bg-blue-900 inline-flex items-center justify-center text-white relative z-10 mt-12"></div>
              <div class="flex-grow pl-14">
                <div Style="margin-top: -1.15rem;">
                  <h1 class="font-medium title-font text-base font-bold text-gray-500 mb-1 tracking-wider">在线教育平台</h1>
                  <p class="leading-relaxed text-sm text-gray-400">
                    EMHUB在线教育平台提供实时及互动性的在线课堂教学。在新冠疫情期间，EMHUB的在线教学实现居家状态下，与世界各地的学生教师无障碍交流，同时平台帮助引进世界各高校的优质课程、分享世界多平台的优质课程资源，与全球学习者共同进步。
                  </p>
                  <a class="inline-flex items-center mt-6 text-sm understandMoreColor cursor-pointer" @click="toEdu(0)">了解更多
                    <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24">
                      <path d="M5 12h14M12 5l7 7-7 7"></path>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

<!--      <div class="flex flex-wrap w-full flex-col items-center text-center mt-4 wrapper overflow-hidden md:px-0 lg:px-0">-->
<!--        &lt;!&ndash;    滑动视频   &ndash;&gt;-->
<!--        <div class="relative w-full">-->
<!--          <swiper class="swiper" :options="swiperOption">-->
<!--            <swiper-slide class="w-48 h-44" v-for="(item,index) in videoList" :key="index">-->
<!--                <video-player-->
<!--                    class="video-player vjs-custom-skin object-cover videoClass"-->
<!--                    ref="videoPlayer"-->
<!--                    :playsinline="true"-->
<!--                    :options="playerOptions[index]"-->
<!--                    @play="onPlayerPlay($event)"-->
<!--                    @pause="onPlayerPause($event)"-->
<!--                    @ended="onPlayerEnded($event)"-->
<!--                    @waiting="onPlayerWaiting($event)"-->
<!--                    @playing="onPlayerPlaying($event)"-->
<!--                    @loadeddata="onPlayerLoadeddata($event)"-->
<!--                    @timeupdate="onPlayerTimeupdate($event)"-->
<!--                    @canplay="onPlayerCanplay($event)"-->
<!--                    @canplaythrough="onPlayerCanplaythrough($event)"-->
<!--                    @statechanged="playerStateChanged($event)"-->
<!--                    @ready="playerReadied"-->
<!--                >-->
<!--                </video-player>-->
<!--            </swiper-slide>-->
<!--          </swiper>-->
<!--          <div class="swiper-button-prev" slot="button-prev"></div>-->
<!--          <div class="swiper-button-next" slot="button-next"></div>-->
<!--        </div>-->
<!--      </div>-->
    </div>

    <div class="px-4 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl sm:px-6 md:px-8 lg:px-10">
      <div class="flex flex-wrap w-full flex-col items-center text-center mt-4 wrapper overflow-hidden md:px-0 lg:px-0">
        <!--    滑动视频   -->
        <div
          v-if="playerOptions.length > 0"
          class="relative w-full"
        >
          <swiper class="swiper" :options="swiperOption" style="width: 1024px;">
            <swiper-slide class="w-48 h-44" v-for="(item,index) in videoList" :key="index">
              <video-player
                  class="video-player vjs-custom-skin object-cover videoClass"
                  ref="videoPlayer"
                  :playsinline="true"
                  :options="playerOptions[index]"
                  @play="onPlayerPlay($event)"
                  @pause="onPlayerPause($event)"
                  @ended="onPlayerEnded($event)"
                  @waiting="onPlayerWaiting($event)"
                  @playing="onPlayerPlaying($event)"
                  @loadeddata="onPlayerLoadeddata($event)"
                  @timeupdate="onPlayerTimeupdate($event)"
                  @canplay="onPlayerCanplay($event)"
                  @canplaythrough="onPlayerCanplaythrough($event)"
                  @statechanged="playerStateChanged($event)"
                  @ready="playerReadied"
              >
              </video-player>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
baseOSSUrl
} from '@/utils/oss';
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from 'vue-awesome-swiper';
export default {
  name: 'homeOnlineEduVideo',
  components:{
    // BScroll,
    swiper,
    swiperSlide
  },
  data(){
    return {
      baseOSSUrl,
      options: {
        playbackRates: [0.75, 1.0, 1.5, 2.0 ], // 可选的播放速度
        autoplay: false, // 是否自动播放
        muted: false, // 是否静音 默认情况下将会消除任何音频
        loop: false, // 是否开启循环播放
        preload: "auto", // 自动预加载
        language: "zh-CN", // 语言，'en', 'zh-cn', 'zh-tw'
        aspectRatio: "16:9", // 播放器高宽占比（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        flash:{hls:{withCredentials:false}},
        html5:{hls:{withCredentials: false}},
        sources: [{
          type: "video/mp4", // 类型
          src: baseOSSUrl + "/yzjh.mp4"
        }],
        poster: baseOSSUrl + '/new1.jpg', // 封面地址
        width:document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 是否显示当前时间和持续时间的分隔符，"/"
          durationDisplay: true, // 是否显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间
          fullscreenToggle: true, // 是否显示全屏按钮
        },
      },
      wrapScroll: {}, //滚动容器对象
      videoElement: [], // 创建一个数组
      //视频的一些属性集合
      playerOptions:[],
      //后端给到的视频集合
      videoList: [{
        type:"video/mp4",
        url:baseOSSUrl + "/1Jose%CC%81%20Luis%20Pomar_Mitral%20valve%20anatomy.mp4",
        poster: baseOSSUrl + '/1.jpg'
      },{
        type:"video/mp4",
        url:baseOSSUrl + "/2.Dr.%20Marta%20Sitges.mp4",
        poster: baseOSSUrl + '/2.jpg'
      },{
        type:"video/mp4",
        url:baseOSSUrl + "/3.Jose%CC%81%20Luis%20Pomar%2C%20MD%2C%20PhD-18.mp4",
        poster: baseOSSUrl + '/3.jpg'
      },{
        type:"video/mp4",
        url:baseOSSUrl + "/4.Dr.%20Daniel%20Pereda%E5%BE%AE%E5%88%9B%E4%BA%8C%E5%B0%96%E7%93%A3%E6%89%8B%E6%9C%AF.mp4",
        poster: baseOSSUrl + '/4.jpg'
      },{
        type:"video/mp4",
        url:baseOSSUrl + "/5_Dr.%20Arzamendi%E7%BB%8F%E5%AF%BC%E7%AE%A1%E4%BA%8C%E5%B0%96%E7%93%A3%E4%BF%AE%E5%A4%8D%E6%9C%AF.mp4",
        poster: baseOSSUrl + '/5.jpg'
      },{
        type:"video/mp4",
        url:baseOSSUrl + "/6_Jeroen%20Bax_The%20most%20recent%20Guidelines%20on%20Mitral%20Valve%20Disease.mp4",
        poster: baseOSSUrl + '/6.jpg'
      },{
        type:"video/mp4",
        url:baseOSSUrl + "/7_Dr.%20Song%20GuangyuanTranscatheter%20Edge-to-Edge%20Repair%20for%20Complex%20Mitral%20Regurgitation%EF%BC%8C.mp4",
        poster: baseOSSUrl + '/7.jpg'
      }],
      currentPlayer: null,


      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 30,
        slidesPerGroup: 3,
        // loop: true,
        // loopFillGroupWithBlank: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  methods: {
    // 播放回调
    onPlayerPlay($event) {
      //解决视频可以多个并行播放的问题，实现唯一视频播放，使用中间变量存放当前播放视频，播放其他视频时，暂停当前视频即可
      if (this.currentPlayer && $event != this.currentPlayer){
        this.currentPlayer.pause()
      }
      this.currentPlayer = $event
    },
    // 暂停回调
    onPlayerPause($event) {
      // console.log("player pause!", $event);
    },
    // 视频播完回调
    onPlayerEnded($event) {
      // console.log($event);
    },
    // DOM元素上的readyState更改导致播放停止
    onPlayerWaiting($event) {
      // console.log($event);
    },
    // 已开始播放回调
    onPlayerPlaying($event) {
      // console.log($event);
    },
    // 当播放器在当前播放位置下载数据时触发
    onPlayerLoadeddata($event) {
      // console.log($event);
    },
    // 当前播放位置发生变化时触发。
    onPlayerTimeupdate($event) {
      // console.log($event);
    },
    //媒体的readyState为HAVE_FUTURE_DATA或更高
    onPlayerCanplay($event) {
    },
    //媒体的readyState为HAVE_ENOUGH_DATA或更高。这意味着可以在不缓冲的情况下播放整个媒体文件。
    onPlayerCanplaythrough($event) {
    },
    //播放状态改变回调
    playerStateChanged($event) {
      // console.log("player current update state", $event);
    },
    //将侦听器绑定到组件的就绪状态。与事件监听器的不同之处在于，如果ready事件已经发生，它将立即触发该函数。。
    playerReadied() {
      // console.log("example player 1 readied");
    },

    //跳转教育页面
    toEdu(value){
      this.$router.replace({
        name:'edu',
        query:{
          tabIndex: value
        }
      })
    },
  },
  created() {
    for(var key in this.videoList){
      var obj ={
        playbackRates: [0.75, 1.0, 1.5, 2.0 ], // 可选的播放速度
        autoplay: false, // 是否自动播放
        muted: false, // 是否静音 默认情况下将会消除任何音频
        loop: false, // 是否开启循环播放
        preload: 'metadata', // 自动预加载
        language: "zh-CN", // 语言，'en', 'zh-cn', 'zh-tw'
        aspectRatio: "16:9", // 播放器高宽占比（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        flash:{hls:{withCredentials:false}},
        html5:{hls:{withCredentials: false}},
        sources: [{
          type: this.videoList[key].type, // 类型
          src: this.videoList[key].url, // url地址
        }],
        poster: this.videoList[key].poster, // 封面地址
        width:document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 是否显示当前时间和持续时间的分隔符，"/"
          durationDisplay: true, // 是否显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间
          fullscreenToggle: true, // 是否显示全屏按钮
        },
      }
      this.playerOptions.push(obj);
    }

  },
  mounted () {
    this.$nextTick(() => {
      this.videoElement = document.getElementsByTagName('video-player') // 获取页面上所有的video对象
    })
  },
}
</script>

<style scoped>
  .understandMoreColor{
    color: #123B7F;
  }

  .swiper-button-next, .swiper-container-rtl .swiper-button-prev {
    background-image: url("//emhub-static-assets3.oss-cn-hangzhou.aliyuncs.com/right.png");
    background-size: 27px;
    right: 30px;
    left: auto;
  }

  .swiper-button-prev, .swiper-container-rtl .swiper-button-next {
    background-image: url("//emhub-static-assets3.oss-cn-hangzhou.aliyuncs.com/left.png");
    background-size: 27px;
    left: 30px;
    right: auto;
  }
</style>
